<template>
    <b-container fluid class="overview">
        <h1 class="text-left mb-4">{{ $t('menuItemTableResults') }}</h1>
        <b-badge v-show="loading" variant="primary">{{
            $t('loading')
        }}</b-badge>
        <template v-if="tableResults && tableResults.length > 0">
            <div class="row">
                <!-- Search field -->
                <search-box
                    id="searchTableResults"
                    @input="$_onInput"
                    :info="$t('searchInfo')"
                    :autofocus="true"
                    :value="searchText"
                    :saveInState="true"
                >
                </search-box>
                <b-link class="px-1 pt-2" @click="$_clearFilters()">
                    {{ $t('clearFilter') }}
                </b-link>
            </div>
            <!-- Overview Table -->
            <b-table
                striped
                hover
                small
                outlined
                bordered
                @row-clicked="$_onDetails"
                tbody-tr-class="tablerow"
                :sort-by.sync="sortBy"
                :items="filteredRecords"
                :fields="fields"
                sort-icon-left
            >
            </b-table>
        </template>
        <!-- No content for overview -->
        <div
            v-if="(!tableResults || tableResults.length === 0) && !loading"
            class="col-md-12"
        >
            <span>{{ $t('tableResults.nonePresent') }}</span>
        </div>
        <router-links-footer :routerLinks="[{ name: 'tableResultNew' }]" />
    </b-container>
</template>

<script>
    import SearchBox from '../../components/SearchBox.vue';
    import RouterLinksFooter from '../../components/dashboard/RouterLinksFooter.vue';
    import { arraySortAscendingFunction } from '../../services/utilities';
    export default {
        components: {
            'search-box': SearchBox,
            'router-links-footer': RouterLinksFooter
        },
        data() {
            return {
                searchText: '',
                fields: [
                    {
                        key: 'name',
                        label: this.$t('columnNameName'),
                        sortable: true,
                        stickyColumn: true,
                        class: 'text-left',
                        thStyle: { border: 0 }
                    },
                    {
                        key: 'title',
                        label: this.$t('columnNameTitle'),
                        sortable: true,
                        class: 'text-left',
                        thStyle: { border: 0 }
                    },
                    {
                        key: 'tableName',
                        label: this.$t('tableResults.tableName'),
                        sortable: true,
                        class: 'text-left',
                        thStyle: { border: 0 }
                    }
                ],
                sortBy: 'name',
                tableResults: null,
                loading: null
            };
        },
        async created() {
            this.loading = true;
            const tableResults = await this.$store.dispatch('useApiData', {
                name: 'GetTableSearchResults',
                parameters: {},
                useLoader: true
            });
            this.loading = false;
            this.tableResults = [...tableResults.data].sort(
                arraySortAscendingFunction(this.sortBy)
            );
        },
        computed: {
            filteredRecords() {
                // filter records on name, title, description
                if (this.searchText.length > 0) {
                    const searchText = this.searchText.toLowerCase();
                    return this.tableResults.filter((record) => {
                        return (
                            record.name?.toLowerCase().includes(searchText) ||
                            record.title?.toLowerCase().includes(searchText) ||
                            record.description?.toLowerCase().includes(searchText)
                        );
                    });
                }
                return this.tableResults;
            }
        },
        methods: {
            $_onDetails(record) {
                this.$router.push({ path: `/dashboard/tableresults/${record.id}` });
            },

            $_onInput(searchText) {
                this.searchText = searchText;
            },

            $_clearFilters() {
                this.$_onInput('');
            }
        }
    };
</script>
